import { EXTERNAL_PARTNER } from '~/constants'
import { store } from '~/redux/store'

// ===================== TỔNG HỢP CÁC HÀM XỨ LÝ LIÊN QUAN ĐẾN EXTERNAL PARTNER =====================

// Kiểm tra nhà hàng có tích hợp với smaregi hay không
export const isPartnerSmaregi = () => {
  const externalPartner = store.getState().restaurant.data?.externalPartner

  return externalPartner === EXTERNAL_PARTNER.Smaregi
}

// Kiểm tra nhà hàng có tích hợp với smaregi POS hay không
export const isPartnerSmaregiPOS = () => {
  const externalPartner = store.getState().restaurant.data?.externalPartner

  return externalPartner === EXTERNAL_PARTNER.SmaregiPOS
}

// Kiểm tra xem External partner có phải là NEC hay không
export const isPartnerNEC = () => {
  const externalPartner = store.getState().restaurant.data?.externalPartner

  return externalPartner === EXTERNAL_PARTNER.NEC
}
